import React, { useState } from 'react';
import infoIcon from '../assets/info.svg'
import closeIcon from "../assets/closeIcon.svg"

const FirstWOLoad = (props) => {
    const [initMessage, setInitMessage] = useState(true)
    return (
        <>
            {initMessage ? 
            <div className='initializing'>
                <div id='initializing-icons'>
                    <img className='init-icons' src={infoIcon} alt='infoIcon'/>
                    <button className='init-icons' onClick={() => { setInitMessage(false) }}><img src={closeIcon} alt='CloseButton'/></button>
                </div>
                <div id='initializing-text'>
                    <p>The first log-in takes longer to load all Work Orders. This is normal and will occur on the first login of the day or login after a user has logged out.</p>
                </div>
            </div> : null}
            <h1 className="loading-text">Initializing</h1>
        </>
    )
}
export default FirstWOLoad;